export const successMsgs = {
  addedToWhitelist: 'was added successfully to qualified list',
  removedFromWhitelist: 'was removed successfully from qualified list',
  bulkDriversAddedToWhitelist:
    'Selected drivers were added successfully to qualified list',
  bulkDriversRemovedFromWhitelist:
    "Selected drivers were removed successfully from qualified list",
  bulkDriversUpdateShortly: "Drivers status will be updated in few seconds",
  driverStatusUpdated: "Driver status updated successfully",
  offerCreated: "Offer created successfully",
  offerEdited: "Offer edited successfully",
  offerDeleted: "Offer deleted successfully",
  offerPublished: "Offer published successfully",
  offerUnpublished: "Offer unpublished successfully",
  offerUpdated: "Offer updated successfully",
  tripEnded: "Trip ended successfully",
  animationCreated: "Animation created successfully",
  animationDeleted: "Animation deleted successfully",
  animationUpdated: "Animation updated successfully",
  serviceOfferMarked: "Offer marked as service offer successfully",
  serviceOfferRemoved: "Service offer flag removed successfully",
  challengeCreated: "Challenge created successfully",
  challengeEdited: "Challenge edited successfully",
  challengeSavedAsDraft: "Challenge saved as draft successfully",
  challengePublished: "Challenge published successfully",
  challengeUnpublished: "Challenge unpublished successfully",
  challengeDuplicated: "Challenge duplicated successfully",
  challengeDraftDeleted: "Challenge draft deleted successfully",
  userFlagged: "User was flagged as fraud successfully",
  userUnflagged: "Fraud flag was removed successfully",
};
